<template>
  <div class>
    <div class="row m-0 p-0">
      <b-link
        v-for="(price,index) in chargeAccount.prices"
        :key="index"
        class="predefined-amount text-center col mx-1 mt-1 align-items-center py-2"
        @click="selectPrice(price.value)"
      >
        <strong>{{ price.value }}</strong>
        <span>{{ chargeAccount.unit }}</span>
      </b-link>
    </div>

    <b-row class="d-flex flex-row mt-3">
      <b-col class="flex-column col-xs-8 col-xxs-12">
        <b-input-group class>
          <b-form-input
            v-model="selectedPrice"
            v-validate="{required: true, min_value: minLegalChargeAmount}"
            type="tel"
            class="font-size-small"
            :placeholder="$t('UserProfile.Wallet.ChargeAccount.AmountPlaceholder')"
            name="price"
            :state="validateState('price')"
            aria-describedby="price"
            data-vv-as="UserProfile.Subscription.ChargeWalletFactor.ChargeAmount"
          />
          <b-input-group-append>
            <b-input-group-text slot="append">
              {{ $t('UserProfile.Wallet.ChargeAccount.PriceType') }}
            </b-input-group-text>
          </b-input-group-append>
        </b-input-group>

        <div class="d-flex mt-2 justify-content-end">
          <b-badge
            :class="{'text-danger shake-error':errors.has('price')}"
            variant="light"
          >
            {{ $t('UserProfile.Wallet.ChargeAccount.ChargeLimitTip',{minLegalChargeAmount:chargeAccount.minLegalChargeAmount,unit:chargeAccount.unit}) }}
          </b-badge>
        </div>
      </b-col>
      <b-col class="d-flex flex-column justify-content-between">
        <b-button
          class="mt-xs-0 mt-xxs-3"
          variant="success"
          @click="showeWalletFactor(selectedPrice)"
        >
          {{ $t('UserProfile.Wallet.ChargeAccount.ChargeAccountButton') }}
        </b-button>
        <img
          v-if="!HideGateways"
          class="mt-4 align-self-end"
          width="72"
          height="72"
          src="@/assets/icons/ZarinPal.png"
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'UserProfileChargeWallet',
  props: {
    HideGateways: Boolean
  },
  data () {
    return {
      selectedPrice: '',
      chargeAccount: {
        unit: 'تومان',
        minLegalChargeAmount: 5000,
        prices: [
          { value: 5000 },
          { value: 10000 },
          { value: 50000 },
          { value: 100000 }
        ]
      }
    }
  },
  methods: {
    ...mapActions({
      setChargePrice: 'order/setChargePrice'
    }),
    validateState (ref) {
      if (
        this.fields[ref] &&
        (this.fields[ref].dirty || this.fields[ref].validated)
      ) {
        return !this.errors.has(ref)
      }
      return null
    },
    selectPrice (price) {
      this.selectedPrice = price
    },
    showeWalletFactor (price) {
      this.$validator.validateAll().then(valid => {
        if (!valid) {
          return
        }
        this.setChargePrice(price)
        this.$router.push({ path: 'ChargeWalletFactor' })
      })
    }
  },
  created () {
    this.minLegalChargeAmount = 5000
  }
}
</script>
